export class AlternateModel {
  public AlternateMobileNumber: string;
  public SecondaryApplicantPrimaryMobileNumber: string;
  public SecondaryApplicantAlternateMobileNumber: string;
}
